module.exports = __webpack_public_path__ + "img/bone-white-background.12e6e354.png";